import React from "react";

import * as Icon from "react-feather";

export const SidebarData = [
  {
    label: "Principal",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Main",
    submenuItems: [
      {
        label: "Painel",
        icon: <Icon.Grid />,
        link: "/admin-dashboard",
        submenu: false,
        showSubRoute: false,
      },
      // municipio pode visualizar os itens de menu de convocacao se tiver acesso sim senao nao mostra
      {
        label: "Convocação Rastreamento",
        icon: <Icon.FileText />,
        link: "/convocacao-rastreamento",
        submenu: false,
        showSubRoute: false,
      },
      {
        label: "Convocação Insatisfatórios\ne Alterados",
        multiline: true,
        icon: <Icon.PlayCircle />,
        link: "/convocacao-seguimento",
        submenu: false,
        showSubRoute: false,
      },
      {
        label: "Unificação de Cadastros",
        icon: <Icon.Users />,
        link: "/unificacao-de-cadastros",
        submenu: false,
        showSubRoute: false,
      },
    ],
  },
  {
    label: "Configuração de Acesso",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Gerenciamento",
    submenuItems: [
      {
        label: "Usuários",
        link: "/usuarios",
        icon: <Icon.UserCheck />,
        showSubRoute: false,
        submenu: false,
      },
      {
        label: "Grupo de Acesso",
        link: "/configuracao-grupo-de-acesso",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "Suporte",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Suporte",
    submenuItems: [
      {
        label: "Chamados",
        link: "/chamados",
        icon: <Icon.MessageCircle />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "Relatórios",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Relatorios",
    submenuItems: [
      {
        label: "Relatório de Acesso",
        link: "/usuario-acesso-relatorio",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "Documentos",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Documentos",
    submenuItems: [
      {
        label: "Guia de Utilização",
        link: "/assets/docs/Guia de utilização V4.pdf",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
        external: true,
      },
      {
        label: "Guia de Priorização",
        link: "/assets/docs/guia-priorizacao-para-profissionais-da-atencao-primaria-a-saude_ConeCta-SP.pdf",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false,
        external: true,
      },
    ],
  },
  {
    label: "Sistema",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Sistema",
    submenuItems: [
      {
        label: "Atualizações",
        link: "/atualizacoes",
        icon: <Icon.RefreshCcw />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
  {
    label: "FOSP",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "FOSP",
    submenuItems: [
      {
        label: "Importação Organograma",
        link: "/importacao-organograma",
        icon: <Icon.Upload />,
        showSubRoute: false,
        submenu: false,
      },
    ],
  },
];
